export default __webpack_public_path__ + "static/media/battery.e4d4bd83.svg";